module.exports = __webpack_public_path__ + "static/img/1-1.57d507a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/eng/1-1.png
// module id = wfKb
// module chunks = 0